<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">Category</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div class="col-md-12">
          <div v-if="!categoriesLoaded" class="h-100 d-flex justify-content-center align-items-center">
            <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
          </div>

          <div v-else class="card card-form">
            <div class="card-body">
              <div class="form-section-header">Neuer Category</div>
              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Name <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('category.name')?'is-invalid':''"
                      v-model="category.name"
                      v-validate="'required'"
                      data-vv-name="category.name"
                      data-vv-model="category.name"
                      type="text"
                      placeholder="Category"
                  ></b-form-input>
                  <div v-if="errors.first('category.name')" class="text-danger">Buchtitel bitte eingeben</div>
                </b-col>
              </b-row>


              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Category.lawyer') }}</label>
                </b-col>

                <b-col sm="9">
                  <multiselect
                    id="category_lawyer"
                    name="category_lawyer"
                    v-model="category.lawyer"
                    data-vv-name="category.lawyer"
                    data-vv-model="category.lawyer"
                    :options="lawyersOptions"
                    :searchable="true"
                    deselect-label=""
                    select-label=""
                    selected-label=""
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :placeholder="$t('message.Category.lawyer')"
                    :preselect-first="false"
                    label="name">
                  </multiselect>
                </b-col>
              </b-row>

              <div class="form-buttons">
                <button type="submit" class="btn btn-link" @click="$router.go(-1)">{{ $t('message.cancel') }} </button>
                <button type="submit" class="btn btn-success" @click="proceed">{{ $t('message.proceed') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  import { CATEGORY_REQUEST_BY_ID, CATEGORY_SAVE, CATEGORY_UPDATE, CATEGORY_GET_NEW_ID } from '@/store/actions/categories';
  import Multiselect from 'vue-multiselect';

  export default {
    name: "CreateCategory",

    components: {
      Multiselect
    },

    data() {
      return {
        editor: ClassicEditor,
        editorConfig: {
          // The configuration of the editor.
        },

        category: {
          id: null,
          name: null,
          description: ''
        },

        newRecord: false,
      }
    },

    computed: {
      lawyersOptions() {
        return this.lawyers.map(el => { return {id: el.id, name: el.name} });
      },
    },

    mounted() {
      this.get(this.$route.params.id);

      if (this.$route.params.id == undefined) {
        this.$store.dispatch(CATEGORY_GET_NEW_ID).then(newId => {
          this.category.id = newId
        })

        this.newRecord = true;
      } else {
        this.get(this.$route.params.id);
      }

    },

    methods: {
      proceed() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            if (this.newRecord) {
              return this.save();
            }

            return this.update();
          }
        });
      },

      async save() {
        if (this.category.lawyer !== null) {
          this.category.lawyer = this.lawyers.find(elem => elem.id == this.category.lawyer.id)
        }
        this.category.lawyer = this.lawyers.find(elem => elem.id == this.category.lawyer.id)

        await this.$store.dispatch(CATEGORY_SAVE, this.category)
          .then((response) => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullyAdded"),
              type: 'success',
              confirmButtonText: 'OK'
            });

            this.newRecord = false;
            this.$router.push({name: 'CategoryList'})
          })
          .catch(error => {
            console.log(`error ${error}`)
          })
      },

      async update() {
        if (this.category.lawyer !== null) {
          this.category.lawyer = this.lawyers.find(elem => elem.id == this.category.lawyer.id)
        }

        await this.$store.dispatch(CATEGORY_UPDATE, this.category)
          .then(response => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullyUpdated"),
              type: 'success',
              confirmButtonText: 'OK'
            });

            this.$router.push({name: 'CategoryList'})
          }).catch(error => {
            console.log(`error 127 ${error}`)
          });
      },

      async get(id) {
        if (id != undefined) {
          this.$store.dispatch(CATEGORY_REQUEST_BY_ID, id).then(category => {
            this.category = category;
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
  }
</script>


<style scoped>

</style>